module.exports = __webpack_public_path__ + "static/media/menu-dispositivo.d44cdfcb.svg";